import { render, staticRenderFns } from "./MyPageNewActivities.vue?vue&type=template&id=6ae77e28&"
import script from "./MyPageNewActivities.vue?vue&type=script&lang=js&"
export * from "./MyPageNewActivities.vue?vue&type=script&lang=js&"
import style0 from "./MyPageNewActivities.vue?vue&type=style&index=0&id=6ae77e28&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports